import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { GET_ALL_VEHICLES_QUERY_KEY } from './useServerLogisticVehicle'
import { mockedData } from '../mock/mocked'
import { Vehicle } from '@/interfaces/vehicle'

export function useLogisticVehicle() {
  const queryClient = useQueryClient()

  const [showNewVehicle, setShowNewVehicle] = useState<boolean>(false)
  const refetch = () =>
    queryClient.invalidateQueries({ queryKey: [GET_ALL_VEHICLES_QUERY_KEY] })

  const [dataTable, setDataTable] = useState<Vehicle[]>(mockedData.slice(0, 5))
  const [currentPage, setCurrentPage] = useState(1)

  const goToPage = (page: number) => {
    setCurrentPage(page)
    setDataTable(mockedData.slice((page - 1) * 5, page * 5))
  }
  const goToNextPage = () => {
    setCurrentPage(currentPage + 1)
    setDataTable(mockedData.slice(currentPage * 5, (currentPage + 1) * 5))
  }
  const goToPreviousPage = () => {
    setCurrentPage(currentPage - 1)
    setDataTable(mockedData.slice((currentPage - 2) * 5, (currentPage - 1) * 5))
  }

  const search = {
    action: (searchQuery: string) => {
      if (searchQuery !== '')
        setDataTable(
          mockedData.filter((item) => item.name.includes(searchQuery))
        )
      else
        setDataTable(mockedData.slice((currentPage - 1) * 5, currentPage * 5))
    },
    placeholder: 'Buscar expediente',
  }

  const onClose = () => {
    //setEditExpedient(undefined)
    setShowNewVehicle(false)
  }

  const paginate = {
    currentPage: currentPage,
    totalItems: mockedData.length,
    goToPage,
    goToNextPage,
    goToPreviousPage,
  }

  const onEditClick = () => {
    setShowNewVehicle(true)
  }

  const onNewVehicle = () => {
    setShowNewVehicle(true)
  }
  const onChangeFilter = (newFilters: Record<string, string>) => {
    setDataTable(
      mockedData.filter((item) => newFilters['type'].includes(item.type))
    )
  }

  return {
    dataTable,
    search,
    refetch,
    paginate,
    onEditClick,
    showNewVehicle,
    onNewVehicle,
    onClose,
    onChangeFilter,
  }
}
